module.exports = __webpack_public_path__ + "static/media/colin.61bb0d8a.JPG";